import React, { useState, useEffect, useCallback } from 'react';
import Grid from '@mui/material/Grid2';
import { faAngleRight, faChevronLeft, faChevronRight, faFilter, faFilterCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { faPenToSquare, faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { apiService } from '../../services/apiService';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Box } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Select from 'react-select';
function Solutions() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        status: '',
    });
    const [roots, setRoots] = useState([]);
    const [loading, setLoading] = useState(true);
    const [savesbtnloading, setSavesbtnloading] = useState(false);
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRecord, setShowRecord] = useState(20);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [errors, setErrors] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [editId, setEditId] = useState(null);
    const [show, setShow] = useState(false);
    const [selectedRootId, setSelectedRootId] = useState(null);
    const handleClose = () => setShow(false);

    // Filter
    const [isGridVisible, setGridVisible] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchActive, setSearchActive] = useState("");
    const toggleGrid = () => {
        setGridVisible((prev) => !prev);
    };

    const fetchRoots = useCallback(async (params = {}, per_page = selectedRecord) => {
        setLoading(true);
        try {
            const queryString = new URLSearchParams({
                ...params,
                per_page
            }).toString();
            const response = await apiService.getRequest(`/solutions?${queryString}`);
            if (response && response.success === true) {
                setRoots(response.data);
                setPaginateData(response.meta);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, [selectedRecord]);
    const handleSearch = () => {
        fetchRoots({ search: searchQuery, status: searchActive  });
        setCurrentPage(1);
    };
    const cancelSearch = () => {
        fetchRoots({ search: "", status: "" });
        setCurrentPage(1);
        setSearchActive("");
        setSearchQuery("");
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchRoots({ page: newPage, search: searchQuery, status: searchActive });
    };

    useEffect(() => {
        fetchRoots();
    }, [fetchRoots]);

    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        // Clear the error for the specific field being modified
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));

        setFormData({ ...formData, [name]: value });
    };
    
    const handleStatusChange = (selectedOptions) => {
        // const selectedValues = selectedOptions.map(option => option.value);
        setSelectedStatus(selectedOptions);
        setFormData({ ...formData, status: selectedOptions?.value });
        // Clear the Ownedby Group error when a group is selected
        setErrors((prevErrors) => ({
            ...prevErrors,
            status: '',
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.name) newErrors.name = "Name is required.";
        if (!formData.description) newErrors.description = "Description is required.";
        if (formData.status.length === 0) newErrors.status = "Status is required.";
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        try {
            if (editMode && editId) {
                setSavesbtnloading(true);
                // Update the existing article
                const response = await apiService.putRequest(`/solutions/${editId}`, formData);
                if (response && response.success === true) {
                    toast(response.message || "Updated Successfully!");
                    setEditMode(false);
                    setEditId(null);
                    setFormData({
                        name: '',
                        description: '',
                        status: '',
                    })
                    setSelectedStatus([]);
                    fetchRoots({ page: currentPage, search: searchQuery, status: searchActive  });
                    setErrorMessage("");
                }else{
                    if (response.errors) {
                        setErrors(response.errors);
                    }
                    setErrorMessage(response && response.message);
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            } else {
                setSavesbtnloading(true);
                const response = await apiService.postRequest('/solutions', formData);
                if (response && response.success) {
                    toast(response.message || "Submitted Successfully!")
                    setFormData({
                        name: '',
                        description: '',
                        status: '',
                    })
                    setSelectedStatus([]);
                    fetchRoots({ search: searchQuery, status: searchActive  });
                    setCurrentPage(1);
                }else{
                    if (response.errors) {
                        setErrors(response.errors);
                    }
                    setErrorMessage(response && response.message);
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }finally{
            setSavesbtnloading(false);
        }
    };
    const handleCancel = () => {
        setFormData({
            name: '',
            description: '',
            status: '',
        })
        setEditMode(false);
        setEditId(null);
        setSelectedStatus([]);
        setErrorMessage("");
        setErrors({});
    };
    const handleEdit = async (id) => {
        try {
            const response = await apiService.getRequest(`/solutions/${id}`);
            if (response && response.success) {
                setFormData({
                    name:response.data.name,
                    description:response.data.description,
                    status:response.data.status,
                })
                setSelectedStatus({
                    value: response.data.status?.value,
                    label: response.data.status === 1 ? "Active" : "Inactive"
                });
                
                setEditMode(true); // Enable edit mode
                setEditId(id); // Store the ID of the article being edited
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching article:', error);
        }
    };


    
    const handleShow = (rootId) => {
        setSelectedRootId(rootId);
        setShow(true);
    };

    const handleDelete = async () => {
        try {
            const response = await apiService.deleteRequest(`/solutions/${selectedRootId}`); // Call DELETE API
            if(response && response.success === true){
                setRoots(roots.filter(roots => roots.id !== selectedRootId)); // Remove deleted member from state
                toast(response.message || 'Solution deleted successfully!');
            }else{
                toast(response.message);
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            console.log(err,"Failed to delete");
        }
        handleClose();
    };

    const [showDataModal, setShowDataModal] = useState(false);
    const [modalData, setModalData] = useState(null);
    
    const handleCloseData = () => setShowDataModal(false);
    
    const handleShowData = (data) => {
        setModalData(data);
        setShowDataModal(true);
    };
    const sanitizeAndDisplayHTML = (html) => {
        if (!html) return '';

        // Handle both \n and \r\n (Windows/Mac/Linux line endings)
        const formattedHTML = html
            .replace(/(\r\n|\r|\n){2,}/g, '<br><br>') // double line breaks
            .replace(/(\r\n|\r|\n)/g, '<br>');        // single line breaks

        return formattedHTML;
    };
    const rows = roots.map((datas,index) => ({
        index:paginatedata?.from + index,
        id: datas.id,
        name: datas.name,
        description: datas.description || "No Description",
        status: datas.status || "No Status",        
    }));
    const columns = [
        {
            field: 'index',
            headerName: '#',
            width: 80,
            filterable: false,
            sortable: true,
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 200,
            filterable: false,
            sortable: false,
            renderCell: (params) => (
                <Grid size={{ xs: 12 }} container alignItems="center" justifyContent="flex-start" className="gap-md-3 h-100 gap-2">
                    <button className='editbtnroot' onClick={() => handleEdit(params.row.id)}>
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                    <button className='trashbtnroot' onClick={() => handleShow(params.row.id)}>
                        <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                </Grid>
            ),
        },
        {
            field: 'name',
            headerName: 'Name',
            width: 300,
            filterable: false,
            sortable: true,
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 300,
            filterable: false,
            sortable: false,
            renderCell: (params) => (
                <Grid size={{ xs: 12 }} container alignItems="center" justifyContent="flex-start" className="gap-md-3 h-100 gap-2">
                {params.row.description ? (
                    <button
                    style={{width:"max-content" ,height:"30px"}}
                    className='registersendbtn2 px-4 my-0 d-flex justify-content-center align-items-center'
                    onClick={() => handleShowData(params.row.description)}
                    >
                        View
                    </button>
                ) : (
                'N/A'
                )}
                </Grid>
            ),
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 300,
            filterable: false,
            sortable: true,
            renderCell: (params) => (
                <Grid size={{ xs: 12 }} container alignItems="center" justifyContent="flex-start" className="gap-md-3 h-100 gap-2">
                    {params.row.status === 1 ? "Active" : "Inactive"}
                </Grid>
            ),
        },
        
    ];
    return (
        <div className='container-fluid px-0'>
            <div className='content_container'>
                <Grid size={{ sm: 12 }} container justifyContent="space-between" className="main_jobseeker">
                    <Grid size={{ sm: 12 }} container alignItems="center">
                        <Grid size={{ md: 8, xs: 12 }} container flexDirection="column" className="jobseekerhead">
                            <h3>Case Management</h3>
                            <span><b onClick={() => navigate("/dashboard")}>Dashboard</b> 
                            <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                            Case Management 
                            <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                            Solutions</span>
                        </Grid>
                    </Grid>
                    <Grid size={{ sm: 12 }} container justifyContent="space-between" className="flex-md-row-reverse">
                        <Grid size={{ sm: 4, xs: 12 }} container alignContent="flex-start" alignItems="flex-start" className="my-4 knowledge_baseboxes">
                            <h4>{editMode ? "Edit": "Add"} Solution</h4>
                            <Grid size={{ xs: 12 }} container justifyContent="flex-end" className="addlister_base mt-2 pt-2">
                                <label>Name<small className='red_starimpo'>*</small></label>
                                <input 
                                    placeholder="Enter Name"
                                    name='name'
                                    value={formData.name}
                                    onChange={handleInputChange} 
                                    className='py-4'
                                />
                                {errors.name && <p style={{ color: 'red', width: '100%' }}>{errors.name}</p>}
                                <label>Description<small className='red_starimpo'>*</small></label>
                                <textarea placeholder="Enter Description"
                                    // value={description}
                                    name='description'
                                    value={formData.description}
                                    onChange={handleInputChange}
                                     className='py-2'/>
                                {errors.description && <p style={{ color: 'red', width: '100%' }}>{errors.description}</p>}
                                <label>Status<small className='red_starimpo'>*</small></label>
                                <Select
                                    isClearable
                                    name="status"
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                    options={[
                                        { label: "Active", value: 1 },
                                        { label: "Inactive", value: 0 },
                                    ]}
                                    className="basic-multi-select w-100"
                                    classNamePrefix="select"
                                    placeholder="Choose Status..."
                                />
                                {errors.status && <p style={{ color: 'red', width: '100%' }}>{errors.status}</p>}
                                {errorMessage && <p style={{ color: 'red', width: '100%', marginTop:"10px" }}>{errorMessage}</p>}
                                <button
                                onClick={handleSubmit}
                                >
                                {savesbtnloading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : <>{editMode ? 'Update' : 'Create'}</>}
                                </button>
                                {editMode && (
                                    <button className='cancel_btneditmode' onClick={handleCancel} style={{ marginLeft: '10px' }}>
                                        Cancel
                                    </button>
                                )}
                            </Grid>
                        </Grid>
                        <Grid size={{ md:7.8,sm: 6.8, xs: 12 }} container justifyContent="flex-end" alignContent="flex-start" className="my-4 knowledge_baseboxes">
                            <h4>Solutions</h4>
                            {isGridVisible && 
                            <Grid size={{ xs: 12 }} container className="regiter_inputs gap-2">
                                <Grid size={{xs:3.8}} container flexDirection="column" className="mt-3">
                                    <label>Name / Description Search</label>
                                    <input type='text' placeholder='search' className='mb-0'
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}/>
                                </Grid>
                                <Grid size={{xs:3.8}} container flexDirection="column" className="mt-3">
                                    <label>Status</label>
                                    <select value={searchActive} className='mb-0' onChange={(e) => setSearchActive(e.target.value)}>
                                        <option value="">Select</option>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                </Grid>
                            </Grid>}
                            <Grid size={{xs:12}} container className="mt-3 mb-3 gap-3">
                                <button className='bluebtn_secondary mb-0' onClick={toggleGrid}>
                                    {isGridVisible ?<> Hide Filter <FontAwesomeIcon icon={faFilterCircleXmark} /> </> :<> Show Filter <FontAwesomeIcon icon={faFilter} /> </>}
                                </button>
                                {isGridVisible && <>
                                <button className='registersendbtn2 my-0' onClick={handleSearch}>Apply</button>
                                <button className='registersendbtn1 my-0' onClick={cancelSearch}>Clear</button></>}
                            </Grid>
                            <div className='overflowwer_fullwidth w-100'>
                                {loading ? 
                                    <div className='d-flex justify-content-center w-100'>
                                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                                    </div> :<>
                                    {roots && roots.length > 0 ? (
                                        <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi">
                                            <DataGrid
                                                style={{minHeight:"200px"}}
                                                rows={rows}
                                                columns={columns}
                                                disableSelectionOnClick
                                                components={{ Toolbar: GridToolbar }}
                                            />
                                        </Box>
                                    ) : (
                                        <div className="w-100 d-flex justify-content-center mt-4">
                                            <p>No data to display</p>
                                        </div>
                                    )}
                                </>}
                            </div>

                            <Grid size={{xs:12}} container justifyContent="space-between" className="mt-3">
                                <div className='d-flex justify-content-end align-items-center'>
                                    <label className='me-2'>Showing records <b>{paginatedata.from}</b>-<b>{paginatedata.to}</b> out of <b>{paginatedata.total}</b></label>
                                </div>
                                <div className='d-flex justify-content-end datatable_jobpagi align-items-center'>
                                    <label className='me-2'>No. of Rows</label>
                                    <select
                                        label="Rows per page"
                                        value={selectedRecord || 20}
                                        onChange={(e) => {
                                            const value = Number(e.target.value);
                                            setShowRecord(value);
                                            setCurrentPage(1);
                                        }}
                                        sx={{ mr: 2 }}
                                    >
                                        {[5, 10, 20, 50].map((size) => (
                                            <option key={size} value={size}>{size}</option>
                                        ))}
                                    </select>
                                </div>
                            </Grid>
                            <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange(currentPage - 1)} 
                                    disabled={currentPage === 1}>
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                                {paginatedata && paginatedata.last_page > 0 && (
                                    <div className="pagination">
                                        {(() => {
                                        const totalPages = Math.max(1, paginatedata.last_page);
                                        const pages = [];

                                        const start = Math.max(2, currentPage - 2);
                                        const end = Math.min(totalPages - 1, currentPage + 2);

                                        // Always show page 1
                                        pages.push(
                                            <button
                                            key={1}
                                            onClick={() => handlePageChange(1)}
                                            className={currentPage === 1 ? 'active' : ''}
                                            >
                                            1
                                            </button>
                                        );

                                        // Ellipsis after page 1 if needed
                                        if (start > 2) {
                                            pages.push(<span key="start-ellipsis">...</span>);
                                        }

                                        // Middle pages
                                        for (let i = start; i <= end; i++) {
                                            pages.push(
                                            <button
                                                key={i}
                                                onClick={() => handlePageChange(i)}
                                                className={currentPage === i ? 'active' : ''}
                                            >
                                                {i}
                                            </button>
                                            );
                                        }

                                        // Ellipsis before last page if needed
                                        if (end < totalPages - 1) {
                                            pages.push(<span key="end-ellipsis">...</span>);
                                        }

                                        // Always show last page (if more than 1)
                                        if (totalPages > 1) {
                                            pages.push(
                                            <button
                                                key={totalPages}
                                                onClick={() => handlePageChange(totalPages)}
                                                className={currentPage === totalPages ? 'active' : ''}
                                            >
                                                {totalPages}
                                            </button>
                                            );
                                        }

                                        return pages;
                                        })()}
                                    </div>
                                )}
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange(currentPage + 1)} 
                                    disabled={currentPage === paginatedata.last_page}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to delete this Solution?</Modal.Body>
                    <Modal.Footer>
                        <button className='modal_cancel' onClick={handleClose}>
                            Cancel
                        </button>
                        <button className='modal_delete' onClick={handleDelete}>
                            Delete
                        </button>
                    </Modal.Footer>
                </Modal>
                <Modal size='lg' centered show={showDataModal} onHide={handleCloseData}>
                    <Modal.Header closeButton>
                        <Modal.Title>Description</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='mb-3'><div className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(modalData) }} /></Modal.Body>
                </Modal>
            </div>
        </div>
    );
}

export default Solutions;
